import {
    GET_CYLINDER_HOLDING_LIMIT_LIST_PROGRESS, GET_CYLINDER_HOLDING_LIMIT_LIST_SUCCESS, GET_CYLINDER_HOLDING_LIMIT_LIST_FAILURE,
    ADD_CYLINDER_HOLDING_LIMIT_PROGRESS, ADD_CYLINDER_HOLDING_LIMIT_SUCCESS, ADD_CYLINDER_HOLDING_LIMIT_FAILURE,
    EDIT_DELETE_CYLINDER_HOLDING_LIMIT_PROGRESS, EDIT_DELETE_CYLINDER_HOLDING_LIMIT_SUCCESS, EDIT_DELETE_CYLINDER_HOLDING_LIMIT_FAILURE,

    RESET_MESSAGE,

} from '../../types/actionTypes';

const initialState = {
    cly_holding_limit: [],
    loginUser: null,
    error: false,
    loading: false,
    message: null
}

const cly_holding_limit_reducer = (state = initialState, action) => {
    switch (action.type) {

        // case GET_CYLINDER_HOLDING_LIMIT_LIST_SUCCESS:
        //     return { ...state, cly_holding_limit: action.cly_holding_limit, loading: false };
        
        case GET_CYLINDER_HOLDING_LIMIT_LIST_SUCCESS:
            return { ...state, cly_holding_limit: action.cyl_holding_limit, loading: false };


        case GET_CYLINDER_HOLDING_LIMIT_LIST_FAILURE:
            return { ...state, loading: false, error: true };
        case GET_CYLINDER_HOLDING_LIMIT_LIST_PROGRESS:
            return { ...state, loading: true, error: false };

        case ADD_CYLINDER_HOLDING_LIMIT_PROGRESS:
            return { ...state, loading: true };
        case ADD_CYLINDER_HOLDING_LIMIT_SUCCESS:
            return { ...state, cly_holding_limit: [...state.cly_holding_limit, action.payload], loading: false, error: false, message: action.payload.message };
        case ADD_CYLINDER_HOLDING_LIMIT_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };

        case EDIT_DELETE_CYLINDER_HOLDING_LIMIT_PROGRESS:
            return { ...state, loading: true };
        case EDIT_DELETE_CYLINDER_HOLDING_LIMIT_SUCCESS:
            return {
                ...state,
                cly_holding_limit: state.cly_holding_limit.map((cly_holding_limit) =>
                    cly_holding_limit.id === action.payload.id ? action.payload : cly_holding_limit
                ),
                message: action.payload.message
            };
        case EDIT_DELETE_CYLINDER_HOLDING_LIMIT_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };

        case RESET_MESSAGE:
            return { ...state, message: null };

        default:
            return state
    }
}

export default cly_holding_limit_reducer;